import React, { memo, useState, useEffect, useRef } from 'react';
import toast from 'react-hot-toast';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import classes from './DrawerMenu.module.scss';
import { useOptions } from './Options';
import { handleLogout } from '../../../../../Redux/action/interactions';

const DrawerMenu = ({ open, toggleFunc }) => {
    const options = useOptions();
    const modules = JSON.parse(localStorage.getItem('modules'))
    const [isModules, setIsModules] = useState(modules);
    const [fetchedModules, setFetchedModules] = useState([]);
    const LOGOUT_SUCCESS = useRef(null)

    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        if (window.env) {
            LOGOUT_SUCCESS.current = window.env.SUCCESS.LOGOUT_SUCCESS
        } else {
            toast.error("Problem in getting ENV File");
        }

        if (modules !== null) {
            let arr = []
            for (let item in options) {
                for (let j in modules) {
                    if (options[item].moduleName === modules[j]) {
                        arr = [...arr, options[item]];

                    }
                }
            }
            let signOut = options.filter((item) => {
                return item.optionName === "Sign Out"
            })

            let changePass = options.filter((item) => {
                return item.optionName === "Change Password"
            })

            let updateApp = options.filter((item) => {
                return item.optionName === "Update App"
            })

            arr =[...arr , updateApp[0]]
            arr = [...arr, changePass[0]]
            arr = [...arr, signOut[0]]

            setFetchedModules(arr)
        }
    }, [])
    const logout = () => {
        localStorage.removeItem('data');
        localStorage.removeItem('userID');
        localStorage.removeItem('modules');
        localStorage.removeItem('location');
        localStorage.removeItem('fetchedLoc');
        navigate("/");
        dispatch(handleLogout());
        toast.success(LOGOUT_SUCCESS.current);
    }


    return (
        <div className={`${classes.DrawerMenu} ${open && classes.Close} `}>
            <div className={classes.OptionsDiv}>
                {fetchedModules.map((item) => {
                    return (
                        <div key={item.id} className={classes.Options} onClick={() => { item.func(); toggleFunc() }}>
                            <span className="material-icons icons">
                                {item.icon}
                            </span>
                            <h2>
                                {item.optionName}
                            </h2>
                        </div>)
                })}

            </div>
        </div>
    )
}

export default memo(DrawerMenu)